import { useModal } from "vue-final-modal";
import BaseAlert from "~/components/Base/Alert.vue";

export const useBaseAlert = (
  title: string,
  message: any,
  isMessageComponent?: boolean,
  buttonLabel?: string
) => {
  // const { open, close } = useModal({
  //   component: BaseAlert,
  //   attrs: {
  //     title,
  //     message,
  //     isMessageComponent: isMessageComponent ?? false,
  //     onConfirm: () => {
  //       close();
  //     },
  //   },
  // });
  // open();

  const baseAlertController = useBaseAlertController();
  baseAlertController.close("dismiss");

  return baseAlertController.openAsync({
    title,
    message,
    isMessageComponent: isMessageComponent ?? false,
    buttonLabel: buttonLabel ?? "Ok",
  });
};
